import api from "../../../services/api";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TextField, Button, Typography, Card, CardContent, MenuItem, Paper } from "@mui/material";
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function PropostaComercialItem() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [codigo, setCodigo] = useState("");
    const [status, setStatus] = useState("");
    const [justificativa, setJustificativa] = useState("");
    const [cliente, setCliente] = useState("");
    const [filePreview, setFilePreview] = useState(null);

    const statusOptions = ["Aprovado", "Encerrado", "Rejeitado", "Aguardando Resposta"];

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/propostacomercial/${id}`);
                setCodigo(response.data.codigo);
                setStatus(response.data.status);
                setJustificativa(response.data.justificativa);
                setCliente(response.data.cliente);
            } catch (error) {
                console.error("Erro ao buscar a proposta:", error);
            }
        }
        fetchData();
    }, [id]);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
        if (selectedFile) {
            setFilePreview(URL.createObjectURL(selectedFile));
            setFileName(selectedFile.name);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append("codigo", codigo);
        formData.append("status", status);
        formData.append("justificativa", justificativa);
        formData.append("cliente", cliente);
        if (file) {
            formData.append("pdf", file);
        }

        try {
            await api.put(`/propostacomercial/${id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            mostrarAlerta("Proposta atualizada com sucesso!", "success");
            setTimeout(() => {
                navigate("/propostacomercial");
            }, 1500);
        } catch (error) {
            mostrarAlerta("Erro ao atualizar a proposta!", "error");
        }
    };

    return (
        <PageContainer sx={{ maxWidth: 600 }}>
            <Paper component="form" onSubmit={handleSubmit} sx={{ p: { xs: 2, sm: 4 }, display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600 }} align="center">Atualizar Proposta Comercial</Typography>
                <TextField
                    label="Código"
                    variant="outlined"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value)}
                    required
                />
                <TextField
                    label="Cliente"
                    variant="outlined"
                    value={cliente}
                    onChange={(e) => setCliente(e.target.value)}
                    required
                />
                <TextField
                    select
                    label="Status"
                    variant="outlined"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                >
                    {statusOptions.map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    label="Justificativa"
                    variant="outlined"
                    value={justificativa}
                    onChange={(e) => setJustificativa(e.target.value)}
                />
                <Button variant="contained" component="label">
                    Anexar PDF
                    <input type="file" hidden accept="application/pdf" onChange={handleFileChange} />
                </Button>
                {fileName && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Arquivo: {fileName}
                    </Typography>
                )}
                {filePreview && (
                    <Card sx={{ mt: 2 }}>
                        <CardContent>
                            <Typography variant="body1">Arquivo selecionado:</Typography>
                            <a href={filePreview} target="_blank" rel="noopener noreferrer">Visualizar Documento</a>
                        </CardContent>
                    </Card>
                )}
                <Button type="submit" variant="contained" color="secondary">Atualizar</Button>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default PropostaComercialItem;
